<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.produitDiversDefaut.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitDiversDefaut.tlpe')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ produitsDivers.tlpe }}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitDiversDefaut.fraisTechnique')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{produitsDivers.fraisTechnique }}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitDiversDefaut.pose')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ produitsDivers.pose }}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitDiversDefaut.honoraire')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ produitsDivers.honoraire }}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitDiversDefaut.produitAnnulation')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ produitsDivers.annulation }}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    produitsDivers: {
      type: Object,
      required: true,
    },
  },
};

</script>
